




import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
  AuthService,
  buildOauth2TokenResponse,
  deleteToken,
  storeToken,
  tokenValid,
  updateInfoFromLegalEntity,
  updateInfoFromTokenResponse
} from "../../services/AuthService";
import { isItaly } from "../../services/Helpers";
import { VersionCheckService } from "../../services/VersionCheckService";
import Modal from "../shared/modal/Modal.vue";
import store from "../../vuex/store";
import { LegalEntity } from "@/model/component.model";
import { _keycloak } from "@/bootstrap";

@Component({
  components: {
    MbeModal: Modal
  }
})
export default class LoginNew extends Vue {
  auth: AuthService;
  checkVersionService: VersionCheckService;
  legalEntities: LegalEntity[];
  selectedStore: LegalEntity;
  showStoresModal = false;

  constructor() {
    super();
    this.auth = new AuthService();
    this.checkVersionService = new VersionCheckService();
  }

  created() {
    setTimeout(() => {
      if (this.$route.query.token) {
        let tokenFromHub = null;
        let refreshFromHub = null;
        tokenFromHub = this.$route.query.token;
        refreshFromHub = this.$route.query.refresh;
        const response = buildOauth2TokenResponse(tokenFromHub, refreshFromHub);
        storeToken(response);
        this.initUserInformation(response);
      } else {
        if (!_keycloak.authenticated) {
          window.console.log("Keycloak not authenticated");
          deleteToken();
          _keycloak.login();
        } else {
          const response = buildOauth2TokenResponse(
            _keycloak.token as string,
            _keycloak.refreshToken as string
          );
          storeToken(response);
          if (tokenValid(response)) {
            this.initUserInformation(response);
          } else {
            this.getLegalEntities(response);
          }
        }
      }
    }, 500);
  }

  initUserInformation(response) {
    updateInfoFromTokenResponse(response);
    this.legalEntities = this.extractLegalEntities(response);
    store.commit("updateUserStores", this.legalEntities);
    updateInfoFromLegalEntity(this.legalEntities[0]);
    storeToken(response);
    this.auth.addRefreshLogic();
    this.auth.initApplicationContext(this.$t("no_department").toString());
    this.$router.push("/home");
  }

  extractLegalEntities(userInfo: any) {
    const le: LegalEntity = {
      idEntity: userInfo["legal-entity-id"],
      entityType: userInfo["legal-entity-type"],
      description: ""
    };
    return [le];
  }

  async onStoreModalClosed() {
    this.showStoresModal = false;
    this.auth
      .selectStore(this.selectedStore, this.$t("no_department").toString())
      .then(() => {
        if (
          this.$store.getters.envs.isDev ||
          this.$store.getters.envs.isPreProduction ||
          isItaly()
        ) {
          const showRequestTermConditionAgreement = this.$store.getters[
            "customer/config"
          ].showRequestTermConditionAgreement;
          const showRequestSafeValueAgreement = this.$store.getters[
            "customer/config"
          ].showRequestSafeValueAgreement;
          this.checkVersionService.initVersionCheck();
          this.$router.push({ name: "Home" });
        } else {
          this.$router.push({ name: "Home" });
        }
      })
      .catch(err => {
        setTimeout(() => {
          this.$alerts.danger(this.$t("expired_token").toString()).then(() => {
            deleteToken();
          });
        }, 300);
      });
  }

  getLegalEntities(response: any) {
    this.auth
      .getLegalEntities()
      .then(res => {
        this.legalEntities = res.data as LegalEntity[];
        this.legalEntities = this.legalEntities.filter(
          item => item.entityType === "CUSTOMER"
        );
        if (this.legalEntities.length === 1) {
          if (this.legalEntities[0].entityType === "CUSTOMER") {
            this.selectedStore = this.legalEntities[0];
            this.onStoreModalClosed();
          }
        } else if (this.legalEntities.length > 1) {
          this.showStoresModal = true;
        }
      })
      .catch(err => {
        setTimeout(() => {
          this.$alerts.danger(this.$t("expired_token").toString()).then(() => {
            deleteToken();
          });
        }, 300);
      });
  }
}
